angular.module('ordersSubscription', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);



// WEBPACK FOOTER //
// ./src/app/orders-subscription/orders-subscription.module.js